import React, { useContext, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';

import ScrollIndicator from './components/ScrollIndicator';

import { Context } from '../../context/provider';

import CardStack from './components/CardStack';
import StyledStackView from './stackView.style';
import Timeline from './components/Timeline';
import FilterModal from '../filterModal/filterModal';

const StackView = ({ introCard, filter }) => {
  const { maxScrollPosition } = useContext(Context);
  const [height, setHeight] = useState('auto');

  useEffect(() => {
    if (maxScrollPosition) {
      setHeight(`${maxScrollPosition}px`);
      return;
    }

    setHeight('100vh');
  }, [maxScrollPosition]);

  return (
    <StyledStackView style={{ '--height': height }}>
      <div className="stack-view__inner">
        <FilterModal>{filter}</FilterModal>

        <div className="stack-view__content">
          <motion.div
            className="stack-view__filter"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1, duration: 0.4, ease: 'linear' }}
          >
            {filter}
          </motion.div>

          <CardStack introCard={introCard} className="stack-view__card-stack" />

          <ScrollIndicator className="stack-view__scroll-indicator" />
        </div>

        <div className="stack-view__timeline">
          <Timeline />
        </div>
      </div>
    </StyledStackView>
  );
};

StackView.propTypes = {
  introCard: PropTypes.shape(),
  filter: PropTypes.element.isRequired
};

export default StackView;
